import { render, staticRenderFns } from "./FormTimepickerPlaceholder.vue?vue&type=template&id=30636f6c&"
import script from "./FormTimepickerPlaceholder.vue?vue&type=script&lang=js&"
export * from "./FormTimepickerPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports